import React, { useState } from "react";
import { Container, Nav, Card } from "react-bootstrap";
import { FaBrain, FaChartLine, FaServer, FaBook } from "react-icons/fa";
import AIDashboard from "./AIDashboard";
import AIApplications from "./AIApplications";
import AIServicesDocs from "./AIServicesDocs";

const AIPlatform = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <Container fluid className="py-4 bg-light min-vh-100 fade-in">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold text-dark d-flex align-items-center gap-2 mb-1">
            <FaBrain className="text-primary" /> AI Platform Administration
          </h2>
          <p className="text-muted mb-0">
            Monitor infrastructure health, manage client applications, and explore service documentation.
          </p>
        </div>
      </div>

      {/* Tabs Menu */}
      <Card className="border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
        <Card.Body className="p-0">
          <Nav 
            variant="tabs" 
            activeKey={activeTab} 
            onSelect={(selectedKey) => setActiveTab(selectedKey)}
            className="border-bottom-0 bg-white px-3 pt-2"
          >
            <Nav.Item>
              <Nav.Link 
                eventKey="dashboard" 
                className={`d-flex align-items-center gap-2 px-4 py-3 fw-semibold border-0 rounded-top-4 ${
                  activeTab === "dashboard" ? "text-primary border-bottom border-primary border-3" : "text-muted"
                }`}
                style={{ fontSize: "0.95rem" }}
              >
                <FaChartLine /> Dashboard Statistics
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                eventKey="applications" 
                className={`d-flex align-items-center gap-2 px-4 py-3 fw-semibold border-0 rounded-top-4 ${
                  activeTab === "applications" ? "text-primary border-bottom border-primary border-3" : "text-muted"
                }`}
                style={{ fontSize: "0.95rem" }}
              >
                <FaServer /> Applications Implementation
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                eventKey="docs" 
                className={`d-flex align-items-center gap-2 px-4 py-3 fw-semibold border-0 rounded-top-4 ${
                  activeTab === "docs" ? "text-primary border-bottom border-primary border-3" : "text-muted"
                }`}
                style={{ fontSize: "0.95rem" }}
              >
                <FaBook /> AI Services Documentation
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Body>
      </Card>

      {/* Tab Contents */}
      <div className="tab-content-wrapper">
        {activeTab === "dashboard" && <AIDashboard />}
        {activeTab === "applications" && <AIApplications />}
        {activeTab === "docs" && <AIServicesDocs />}
      </div>

      <style>{`
        .nav-tabs .nav-link {
          transition: all 0.2s ease;
          border-bottom: 3px solid transparent !important;
        }
        .nav-tabs .nav-link:hover {
          color: var(--primary-color) !important;
          background-color: rgba(78, 115, 223, 0.05);
        }
        .nav-tabs .nav-link.active {
          color: #4e73df !important;
          background-color: transparent !important;
          border-bottom: 3px solid #4e73df !important;
        }
        .fade-in {
          animation: fadeIn 0.35s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Container>
  );
};

export default AIPlatform;
